import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RegisterLoginButtons from 'modules/Common/components/RegisterLoginButtons';
import { Lightbox } from 'modules/Common/components/Lightbox';
import { closeLightbox } from 'modules/Common/reducers/display';

@connect(state => ({ lightbox: state.common.display.lightbox }))
export default class BaseLightboxContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    lightbox: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    messagesByType: PropTypes.object,
    type: PropTypes.string.isRequired
  };

  closeLightbox = () => {
    this.props.dispatch(closeLightbox(this.props.type));
  }

  render() {
    const {
      type,
      message,
      messagesByType = {},
      title,
      lightbox: {
        [type]: {
          messageType,
          show = false
        } = {}
      } = {}
    } = this.props;

    const {
      [messageType]: messageToShow = message
    } = messagesByType;

    return (
      show &&
        <Lightbox title={title} close={this.closeLightbox}>
          <span className="subscription-lb-message">{messageToShow}</span>
          <RegisterLoginButtons closeContext={this.closeLightbox}/>
        </Lightbox>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/Lightboxes/BaseLightboxContainer.js